import type { Theme } from '@mui/material/styles'
import type { InventoryLeadStatus } from '@otw/models/leads/inventoryLead'
import { INVENTORY_LEAD_KNOWN_STATUSES } from '@otw/models/leads/inventoryLead'
import { inventoryLeadStatusTone } from 'components/StatusChip'
import { LIGHT_STATUS } from 'core/theme.tokens'

export const INVENTORY_STATUS_NAMES: Record<InventoryLeadStatus, string> = {
  pendingList: 'Pending List',
  fleetConfirmation: 'Fleet confirmation',
  priceNegotiation: 'Price negotiation',
  availableNotPurchased: 'Available not purchased',
  purchasing: 'Purchasing',
  won: 'Won',
  lost: 'Lost',
}

export const inventoryBorderColors = (
  theme?: Theme,
): Record<InventoryLeadStatus, string> => {
  const status = theme?.custom.status ?? LIGHT_STATUS
  return {
    pendingList: status.info.fg,
    fleetConfirmation: status.new.fg,
    priceNegotiation: status.warning.fg,
    availableNotPurchased: status.waiting.fg,
    purchasing: status.purple.fg,
    won: status.success.fg,
    lost: status.danger.fg,
  }
}

export const INVENTORY_BORDER_COLORS = inventoryBorderColors()

const KNOWN_SET = new Set<string>(INVENTORY_LEAD_KNOWN_STATUSES)

export const isDefaultInventoryLeadStatus = (
  status: string,
): status is InventoryLeadStatus => KNOWN_SET.has(status)

export const getInventoryStatusLabel = (
  status: string | InventoryLeadStatus | null | undefined,
): string => {
  if (!status) return INVENTORY_STATUS_NAMES.pendingList
  if (isDefaultInventoryLeadStatus(status)) return INVENTORY_STATUS_NAMES[status]
  return status
}

export const getInventoryBorderColor = (
  status: string | InventoryLeadStatus | null | undefined,
  theme?: Theme,
): string => {
  const palette = theme?.custom.status ?? LIGHT_STATUS
  if (!status) return palette.info.fg
  if (isDefaultInventoryLeadStatus(status)) return inventoryBorderColors(theme)[status]
  return palette.neutral.fg
}
